import { Link } from 'react-router-dom';

const LOGO_URL =
  'https://static.readdy.ai/image/5561bd759c3222152be419fe80f35f20/583116c613df7e9b63549d028eae2fd9.png';

// ─────────────────────────────────────────────────────────────
// Company phone number
// Add it here after you deploy the site, e.g. '+44 20 7946 0958'.
// Leave it empty ('') to keep the phone line hidden.
const COMPANY_PHONE = '';
// ─────────────────────────────────────────────────────────────

export default function Footer() {
  return (
    <footer className="relative pt-14 md:pt-20 pb-0 text-white overflow-hidden">
      {/* Switzerland Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Breathtaking%20Swiss%20Alps%20panorama%20at%20golden%20sunset%2C%20crystal%20clear%20alpine%20lake%20reflecting%20warm%20mountain%20peaks%2C%20lush%20green%20meadows%20with%20wildflowers%20in%20foreground%2C%20dramatic%20sky%20with%20soft%20golden%20clouds%2C%20pristine%20Swiss%20nature%20landscape%2C%20fresh%20vibrant%20colors%2C%20peaceful%20yet%20majestic%20scene%2C%20ultra%20high%20quality%20nature%20photography%2C%20bright%20inspiring%20atmosphere&width=1920&height=900&seq=footer-swiss-alps-2019&orientation=landscape"
          alt="CASA CHERE LIMITED"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay — slightly lighter on mobile so Alps peek through, lighter on desktop */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/82 via-black/78 to-black/88 md:from-black/70 md:via-black/65 md:to-black/85" />
      </div>

      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03] md:opacity-[0.04]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }} />

      <div className="relative z-10 max-w-[1440px] mx-auto px-5 md:px-12">
        {/* Top Grid – Three Columns — with dedicated background on mobile so text never bleeds */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12 pb-8 md:pb-14 border-b border-white/10 bg-black/25 backdrop-blur-sm rounded-xl p-5 md:p-0 md:bg-transparent md:backdrop-blur-none md:rounded-none md:border-b">
          {/* Company */}
          <div className="max-w-xs">
            <div className="flex items-center gap-2.5 mb-4 md:mb-5">
              <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-black ring-1 ring-white/15 flex items-center justify-center overflow-hidden shrink-0">
                <img src={LOGO_URL} alt="CASA CHERE LIMITED" className="w-full h-full object-contain" />
              </span>
              <span className="font-heading font-bold text-base md:text-lg tracking-[1px] text-white whitespace-nowrap">CASA CHERE LIMITED</span>
            </div>
            <p className="text-white/70 md:text-white/50 text-[13px] md:text-sm leading-relaxed">
              A UK premium investment firm with a diversified portfolio spanning real estate, renewable energy, oil &amp; gas, digital assets, and modern medical equipment. Institutional-grade governance since 2013.
            </p>
            <div className="mt-5 md:mt-6 flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 md:border-white/15 text-white/60 md:text-white/40 hover:text-primary-400 hover:border-primary-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 md:border-white/15 text-white/60 md:text-white/40 hover:text-primary-400 hover:border-primary-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm" />
              </a>
            </div>
            <div className="mt-5 md:mt-6 flex flex-col gap-1">
              <span className="text-[10px] uppercase tracking-[2px] text-primary-400 font-medium">Registration</span>
              <span className="text-white/50 md:text-white/30 text-[11px] md:text-xs">Company No. 08549152</span>
              <span className="text-white/50 md:text-white/30 text-[11px] md:text-xs">SIC 68100 – Real Estate</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[10px] uppercase tracking-[3px] text-primary-400 mb-4 md:mb-6">Quick Links</h4>
            <ul className="flex flex-col gap-2.5 md:gap-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'About Us', path: '/about' },
                { label: 'Portfolio', path: '/portfolio' },
                { label: 'Sectors', path: '/sectors' },
                { label: 'Investor Relations', path: '/investor-relations' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-white/70 md:text-white/50 text-[13px] md:text-sm hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Legal */}
          <div>
            <h4 className="text-[10px] uppercase tracking-[3px] text-primary-400 mb-4 md:mb-6">Headquarters</h4>
            <p className="text-white/70 md:text-white/50 text-[13px] md:text-sm leading-relaxed">
              102 Fulham Palace Road<br />
              London, England, W6 9PL<br />
              United Kingdom
            </p>
            <a href="mailto:info@casachere.com" className="text-white/70 md:text-white/50 text-[13px] md:text-sm mt-3 md:mt-4 block hover:text-primary-400 transition-colors cursor-pointer">
              info@casachere.com
            </a>
            {COMPANY_PHONE && (
              <a
                href={`tel:${COMPANY_PHONE.replace(/\s+/g, '')}`}
                className="flex items-center gap-2 text-white/70 md:text-white/50 text-[13px] md:text-sm mt-2 hover:text-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line" />
                {COMPANY_PHONE}
              </a>
            )}

            <h4 className="text-[10px] uppercase tracking-[3px] text-primary-400 mt-6 md:mt-8 mb-3 md:mb-4">Legal</h4>
            <ul className="flex flex-col gap-2">
              <li><a href="/legal" className="text-white/50 md:text-white/30 text-[11px] md:text-xs hover:text-primary-400 transition-colors cursor-pointer">Privacy Policy</a></li>
              <li><a href="/legal" className="text-white/50 md:text-white/30 text-[11px] md:text-xs hover:text-primary-400 transition-colors cursor-pointer">Terms of Use</a></li>
              <li><a href="/legal" className="text-white/50 md:text-white/30 text-[11px] md:text-xs hover:text-primary-400 transition-colors cursor-pointer">Imprint</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 md:py-8 flex flex-col sm:flex-row items-center justify-between gap-3 md:gap-4">
          <p className="text-white/40 md:text-white/20 text-[11px] md:text-xs text-center sm:text-left">
            &copy; 2019 CASA CHERE LIMITED. All rights reserved. Registered in England &amp; Wales &mdash; Company No. 08549152.
          </p>
          <p className="text-white/40 md:text-white/20 text-[11px] md:text-xs text-center italic max-w-md">
            Past performance does not guarantee future results. For professional and accredited investors only.
          </p>
        </div>
      </div>
    </footer>
  );
}